/**
 * Separates react nodes with a given separator.
 *
 * @param nodes The nodes to separate.
 * @param options The options.
 */
export function separateReactNodes(nodes, options) {
    const { separator, nodeTransformFn = (node) => node } = options;
    return nodes
        .map((node, index) => {
        const currentNode = nodeTransformFn(node, index, nodes);
        return index === nodes.length - 1
            ? currentNode
            : [currentNode, separator];
    })
        .flat();
}
